/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import {
  getAdfByDendreoCompanies,
  getActionFormationDetails,
  getDendreoCompanies,
} from '../../../../redux/services/dendreoServices';

export default function DendreoAdfSelect({ value, onChange, group }) {
  const [entreprise, setEntreprise] = useState(null);
  const [loadingInitial, setLoadingInitial] = useState(false);

  const loadEntreprises = async (inputValue) => {
    const res = await getDendreoCompanies(encodeURIComponent(inputValue));
    return res;
  };

  const loadAdfs = async (inputValue) => {
    if (!entreprise?.value) return [];

    const res = await getAdfByDendreoCompanies(entreprise.value, encodeURIComponent(inputValue));
    return res;
  };

  useEffect(() => {
    const fetchInitialAdf = async () => {
      if (!group?.dendreoAdfId || value) return;
      setLoadingInitial(true);
      try {
        const details = await getActionFormationDetails(group.dendreoAdfId);
        if (details) {
          if (details.entreprise) {
            setEntreprise(details.entreprise);
          }
          onChange({
            value: details.action_de_formation.id_action_de_formation ?? group.dendreoAdfId,
            label: details.action_de_formation.intitule,
          });
        }
      } catch (err) {
        // console.error('Erreur récupération action de formation Dendreo:', err);
      } finally {
        setLoadingInitial(false);
      }
    };

    fetchInitialAdf();
  }, [group?.dendreoAdfId]);

  return (
    <div className="space-y-4">
      <AsyncSelect
        cacheOptions
        defaultOptions
        placeholder="Sélectionner une entreprise..."
        loadOptions={loadEntreprises}
        value={entreprise}
        onChange={(option) => {
          setEntreprise(option);
          onChange(null);
        }}
        isClearable
      />

      <AsyncSelect
        key={entreprise?.value || 'no-entreprise'}
        cacheOptions
        defaultOptions
        placeholder={
          loadingInitial
            ? 'Chargement...'
            : entreprise
              ? 'Sélectionner une action de formation...'
              : 'Sélectionnez d’abord une entreprise'
        }
        loadOptions={loadAdfs}
        value={value}
        onChange={onChange}
        isDisabled={!entreprise || loadingInitial}
        isClearable
      />
    </div>
  );
}
